if (!customElements.get("sht-carousel")) {
    class SHTCarousel extends HTMLElement {
      constructor() {
        super();
        this.sectionID = this.dataset.sectionId;
        this.carousels = this.querySelectorAll(".js-carousel-item");
        this.container = this.querySelector(".js-carousel-items");
        this.totalItems = this.carousels.length;
        this.prevBtnElement = this.querySelector(".js-carousel-prev-btn");
        this.nextBtnElement = this.querySelector(".js-carousel-next-btn");
        this.currentElement = this.querySelector(".js-carousel-counter-current");
        this.totalElement = this.querySelector(".js-carousel-counter-total");
        this.init();
        this.bindEventHandlers();
      }
      init() {
        this.itemsToShow = Array.from(this.carousels).filter(
          (element) => element.clientWidth > 0
        );
        if (this.itemsToShow.length < 2) return;
        this.gutter =
          parseFloat(
            window
              .getComputedStyle(this.itemsToShow[1], null)
              .getPropertyValue("padding-left")
          ) +
          parseFloat(
            window
              .getComputedStyle(this.itemsToShow[1], null)
              .getPropertyValue("padding-right")
          );
        this.itemOffset =
          this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft;
        this.itemsPerPage = Math.floor(
          (this.container.clientWidth - this.itemsToShow[0].offsetLeft) /
            this.itemOffset
        );
        // this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
        this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;
        this.updateCarousel();
      }
      updateCarousel() {
        const previousPage = this.currentPage;
        this.currentPage =
          Math.round(this.container.scrollLeft / this.itemOffset) + 1;
        if (this.currentPage > 0 && this.totalPages > 0) {
          if (this.totalElement) {
            this.totalElement.textContent = this.totalPages;
          }
          if (this.currentElement) {
            this.currentElement.innerHTML =
              this.currentPage +
              `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`;
          }
        }
        if (this.currentPage != previousPage) {
          this.dispatchEvent(
            new CustomEvent("itemChanged", {
              detail: {
                currentPage: this.currentPage,
                currentElement: this.itemsToShow[this.currentPage - 1],
                container: this,
              },
            })
          );
        }
        if (
          this.isItemVisible(this.itemsToShow[0]) &&
          this.container.scrollLeft === 0
        ) {
          this.prevBtnElement.setAttribute("disabled", "disabled");
        } else {
          this.prevBtnElement.removeAttribute("disabled");
        }
        if (this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
          this.nextBtnElement.setAttribute("disabled", "disabled");
        } else {
          this.nextBtnElement.removeAttribute("disabled");
        }
      }
      isItemVisible(element, offset = 0) {
        const lastVisibleItem =
          this.container.clientWidth + this.container.scrollLeft - offset;
        return (
          element.offsetLeft + element.clientWidth <= lastVisibleItem &&
          element.offsetLeft >= this.container.scrollLeft
        );
      }
      onButtonClick(event) {
        event.preventDefault();
        let step = 1;
        let gutter = 0;
        const mediaQuery = window.matchMedia("(min-width: 769px)");
        if (mediaQuery.matches) {
          step = event.currentTarget.dataset.step;
        }
        if (
          this.container.scrollLeft == 0 ||
          this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
        ) {
          gutter = this.gutter;
        }
        this.itemScrollPosition =
          event.currentTarget.name === "next"
            ? this.container.scrollLeft - gutter + step * this.itemOffset
            : this.container.scrollLeft + gutter - step * this.itemOffset;
        window.requestAnimationFrame(() =>
          this.container.scrollTo({
            left: this.itemScrollPosition,
            behavior: "smooth",
          })
        );
      }
      bindEventHandlers() {
        const resizeObserver = new ResizeObserver((entries) => this.init());
        resizeObserver.observe(this.container);
  
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
  
          this.init();
          observer.unobserve(this);
        };
        new IntersectionObserver(handleIntersection.bind(this)).observe(this);
  
        this.prevBtnElement.addEventListener(
          "click",
          this.onButtonClick.bind(this)
        );
        this.nextBtnElement.addEventListener(
          "click",
          this.onButtonClick.bind(this)
        );
        this.container.addEventListener(
          "scroll",
          this.debounce(this.updateCarousel.bind(this), 100)
        );
      }
      debounce(fn, delay) {
        let id = null;
        return function (args) {
          clearTimeout(id);
          id = null;
          id = setTimeout(function () {
            fn.call(this, args);
          }, delay);
        };
      }
    }
    customElements.define("sht-carousel", SHTCarousel);
  }
  if (!customElements.get("sht-carousel-item")) {
    class SHTCarouselItem extends HTMLElement {
      constructor() {
        super();
        this.hyperLinks = this.querySelectorAll("a, button");
        this.container = this.closest(".js-carousel-items");
        this.bindEventHandlers();
      }
      bindEventHandlers() {
        this.observeCarouselItem();
      }
      observeCarouselItem() {
        let observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.setCarouselItemVisibility(true);
              } else {
                this.setCarouselItemVisibility(false);
              }
            });
          },
          {
            root: this.container,
            threshold: 0.5,
          }
        );
        observer.observe(this);
      }
      setCarouselItemVisibility(flag) {
        if (!flag) {
          this.setAttribute("aria-hidden", "true");
        } else {
          this.setAttribute("aria-hidden", "false");
        }
        this.setHyperLinkVisibility(flag);
      }
      setHyperLinkVisibility(flag) {
        if (this.hyperLinks) {
          this.hyperLinks.forEach((e) => {
            if (!flag) {
              e.setAttribute("tabindex", "-1");
            } else {
              e.removeAttribute("tabindex");
            }
          });
        }
      }
    }
    customElements.define("sht-carousel-item", SHTCarouselItem);
  }
  
  if (!customElements.get("sht-carousel-trigger")) {
    class SHTCarouselTrigger extends HTMLElement {
      constructor() {
        super();
  
        this.trigger = this.querySelectorAll(".js-carousel-trigger");
        this.carouselWebElement = document.querySelector(
          `#${this.dataset.carouselTarget}`
        );
        this.carousel =
          this.carouselWebElement.querySelector(`.js-carousel-items`);
  
        this.bindEventHandlers();
      }
  
      bindEventHandlers() {
        this.trigger.forEach((e) => {
          e.addEventListener("click", (event) => {
            this.setActiveCarouselElement(event.currentTarget);
          });
        });
  
        this.carouselWebElement.addEventListener("itemChanged", (e) => {
          this.setButtonVisibility(false);
          let buttonElement = this.querySelector(
            `[aria-describedby="${e.detail.currentElement.id}"]`
          );
  
          buttonElement.setAttribute("aria-current", "true");
          buttonElement.classList.add("button--active");
        });
      }
  
      setActiveCarouselElement(el) {
        let carouselItem = this.carousel.querySelector(
          `#${el.getAttribute("aria-describedby", "")}`
        );
  
        if (carouselItem) {
          this.carousel.scrollTo({
            left: carouselItem.offsetLeft,
            behavior: "smooth",
          });
        }
      }
  
      setButtonVisibility(flag) {
        if (this.trigger) {
          this.trigger.forEach((e) => {
            if (flag) {
              e.setAttribute("aria-current", "true");
              e.classList.add("button--active");
            } else {
              e.removeAttribute("aria-current");
              e.classList.remove("button--active");
            }
          });
        }
      }
    }
    customElements.define("sht-carousel-trigger", SHTCarouselTrigger);
  }
  